import React, { useRef, useState, useEffect, useCallback } from "react";
import { API_URL, FOLDERPATH, base_url } from "../Constants/config"
import axios from "axios";
import { Link, useNavigate, useSearchParams} from "react-router-dom";
import OtpInput from "react-otp-input";
import Logo from '../assets/img/ibridge-logo.svg';
import LogoBlue from '../assets/img/ibridge-logo-blue.svg';
import "../assets/css/form.css";
import "../assets/css/login.css";
import "../assets/css/button.css";
import "../assets/css/otp-box.css";
import "../assets/css/style.css"
import BackArrowIcon from "../assets/img/back-arrow-icon.svg";
import LoginImage from "../assets/img/login-image.png";
import { validateEmail, formatOtpMobileNumber } from "../Helper/common";
import Footer from '../components/Footer.js';
import { useDispatch, useSelector } from "react-redux";
import FeatherIcon from "feather-icons-react/build/FeatherIcon.js";
import { loginUser, validateOtp, validateOtpARN } from "../Actions/userActions";

import Loader from "../components/Common/loader.js";
import ReCAPTCHA from "react-google-recaptcha";
import { getTokenVerfy } from "../Actions/TokenAction.js";
import { toast } from "react-toastify";

import keyBlueIcon from "../assets/img/KeyBlue.png"

var Buffer = require("buffer/").Buffer;

const Login = () => {
  const [otpVal1, setOtpVal1] = useState();
  const [otpVal2, setOtpVal2] = useState();
  const [otpVal3, setOtpVal3] = useState();
  const [otpVal4, setOtpVal4] = useState();
   const [otpVal5, setOtpVal5] = useState();
   const [otpVal6, setOtpVal6] = useState();
   const [otpIncomplete,setOtpIncomplete]=useState();
   const [OTPVal, setOTP] = useState("");
   const [showOTP, setShowOTP]=useState(false);
   const [verifyOTPDisabled, setVerifyOTPDisabled] = useState(true);
   const [isLoading, setIsLoading] = useState(true);
   const [recaptchaValue, setRecaptchaValue] = useState('');

  const nav = useNavigate(); 

  const [searchParams, setSearchParams] = useSearchParams();

  const tempStr = searchParams.get('q');
 
  useEffect(()=>{
    const fetch=async()=>{
    const queryParameters = new URLSearchParams(window.location.search)
      let tokenKey=queryParameters.get('tokenKey');
      localStorage.setItem("tokenKey",tokenKey);
      let obj={};
      obj.verifyToken=tokenKey;
      if(tokenKey!=null){
        setShowOTP(true);
      let data=await dispatch(getTokenVerfy(obj));
      setLoginValidated(1);
      setCandidateNumber(data?.data?.mobile);
      console.log(data);
      if(data?.status == 'success'){
        const msg = "OTP sent successfully";
        toast.success(msg, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    }
  }
  fetch();

  },[]);


  
  useEffect(() => {

    const fetchData = async () => {
      let cookie = JSON.parse(localStorage.getItem("userVerificationCandidate"));
      if(cookie?.redirect_insuff) {
        nav("../candidate-form/insuff")
      }else if(cookie){
        nav("../dashboard");
      }

    };

    fetchData();

  }, []);


  const [timer, setTimer] = useState(60);
  const [count,setCount]=useState(1);
  const [isChecked, setIsChecked] = useState(false);

  {
    /*const timeOutCallback = useCallback(() => setTimer(currTimer => currTimer - 1), []);

  useEffect(() => {
    timer > 0 && setTimeout(timeOutCallback, 1000);
  }, [timer, timeOutCallback]);*/
  }


 
  const dispatch = useDispatch();
  let navigate = useNavigate();

  const email = useRef();
  const password = useRef();
  const otp1 = useRef();
  const otp2 = useRef();
  const otp3 = useRef();
  const otp4 = useRef();
  const otp5 = useRef();
  const otp6 = useRef();
  const captcha = useRef();

  const handleOTPChange = (OTPVal) => {
    setOtpIncomplete();
    setOTP(OTPVal);
    if (OTPVal.length == 6) {
      setVerifyOTPDisabled(false);
    } else {
      setVerifyOTPDisabled(true);
    }
  };

  const handleOtpInputs = (e) => {
    

    if(e.target.value.length==2){
      return false;
    }
    if(e.target.name=="otp1"){
      setOtpVal1((v) => (e.target.validity.valid ? e.target.value : ''))
      
      e.target.focus();
    }
    if(e.target.name=="otp2"){
      setOtpVal2((v) => (e.target.validity.valid ? e.target.value : ''))
      
    }
    if(e.target.name=="otp3"){
      setOtpVal3((v) => (e.target.validity.valid ? e.target.value : ''))
      
    }
    if(e.target.name=="otp4"){
      setOtpVal4((v) => (e.target.validity.valid ? e.target.value : ''))
      
    }
    if(e.target.name=="otp5"){
      setOtpVal5((v) => (e.target.validity.valid ? e.target.value : ''))
      
    }
    if(e.target.name=="otp6"){
      setOtpVal6((v) => (e.target.validity.valid ? e.target.value : ''))
      
    }
    
    let currentInput = e.target;
    if(e.target.validity.valid==false){
      e.target.focus();
    }
else{
    if(currentInput.value){
    if (currentInput.nextElementSibling !== null) {
      currentInput.nextElementSibling.focus();
    }
  }
}
if(!currentInput.value){
  //if (currentInput.previousElementSibling !== null) {
    currentInput.previousElementSibling.focus();
 // }
}
// if(e.nativeEvent.inputType=="deleteContentBackward"){
//   currentInput.previousElementSibling.focus();
// }

// if(e.inputType==='deleteContentBackward' && e.atrget.value==='' ){
//   currentInput.nextElementSibling.focus();
// }
  };

  const [isSubmit, setIsSubmit] = useState(false);
  const [formError, setFormError] = useState({});
  const [loginValidated, setLoginValidated] = useState(0);

  const formValidation = (formValues) => {
    const errors = {};

    if (formValues.email === "") {
      errors.email = "This field is required.";
      email.current.style.border = "1px solid red";
    } else {
      email.current.style.border = "1px solid #E1E4EB";
      // if (!validateEmail(formValues.email)) {
      //   errors.email = "Not a valid email addess";
      //   email.current.style.border = "1px solid red";
      // } else {
      //   email.current.style.border = "1px solid #E1E4EB";
      // }
    }

    if (formValues.password === "") {
      errors.password = "This field is required.";
      password.current.style.border = "1px solid red";
    } else {
      password.current.style.border = "1px solid #E1E4EB";
    }

    if (!isChecked) {
      errors.checkbox = "Please agree to Terms & Conditions."
    }else{
      // password.current.style.border = "1px solid #E1E4EB";
    }

    return errors;
  };

  const formData = {};

  const signinHandler = (event) => {
    
    event.preventDefault();
    
    
    // const recaptchaValue = captcha.current.getValue();


    formData.email = Buffer.from(email.current.value).toString("base64");
    formData.password = Buffer.from(password.current.value).toString("base64");
    formData.captcha = recaptchaValue;
    const err = formValidation(formData);
    setIsSubmit(true);
    
    const isValidationPassed = Object.keys(err).length === 0;

    if (!isValidationPassed) {
      setFormError(err);
      window.scroll({ top: 0, left: 0, behavior: "smooth" });
    } else {
      
      dispatch(loginUser(formData,callbackRecaptcha));
     
      setTimer(60);
    }
  };

  const callbackRecaptcha = () => {
    let element = document.body.getElementsByClassName('grecaptcha-badge');
    console.log(element);
    element[1].classList.add('d-none');
  }

  const verifyOtpHandler = (event) => {
    event.preventDefault();

    // const finalOtp =
    //   otp1.current.value +
    //   otp2.current.value +
    //   otp3.current.value +
    //   otp4.current.value +
    //   otp5.current.value +
    //   otp6.current.value;
    if(OTPVal){
      dispatch(validateOtp(OTPVal));
    }
    
  };

  const verifyOtpArnHandler = async(event) => {
    setOtpIncomplete();
    event.preventDefault();

    // const finalOtp =
    //   otp1.current.value +
    //   otp2.current.value +
    //   otp3.current.value +
    //   otp4.current.value +
    //   otp5.current.value +
    //   otp6.current.value;
    if(OTPVal.length == 6){
      let record={};
      let tokenKey=localStorage.getItem("tokenKey");
      record.mobile_otp=OTPVal;
      record.auth_token=tokenKey;
      let result=await dispatch(validateOtpARN(record));
      if(result.message == "You have entered wrong OTP, Please try again"){
      setOtpIncomplete("wrong");
        
      }
    }
    else if(OTPVal.length == 0){
      setOtpIncomplete("incomplete");
    }
    else{
      setOtpIncomplete("wrong");
    }
    
  };

  //////////////////////////////////////
  const storeData = useSelector((state) => state.user);
  const { userData, loading, error } = storeData;


  console.log("er",userData);
  
  console.log("er",userData);
  ////////////////////////////////////////////////////////////////////////////

  //@---whenever listing data loaded set componet states

  const [candidateNumber, setCandidateNumber] = useState("");

  useEffect(() => {
    if (typeof userData !== "undefined" && userData !== null) {
      if (userData?.status === "success") {
        if (userData.data.send_otp === 1) {
          setCandidateNumber(userData.data.candidate_mobile_no);
          setLoginValidated(1);
        } else {
          let tempToken = JSON.parse(localStorage.getItem('tempToken'));
          let array = userData.data;
          array.id = tempToken;
          array.redirect_insuff = userData.redirect_insuff
          localStorage.setItem("userVerificationCandidate", JSON.stringify(array));
          
          if(userData?.redirect_insuff) {
            navigate("../candidate-form/insuff")
          }else{
            navigate("../dashboard");
          }
        }
      }
    }
  }, [userData]);


  useEffect(() => {
    if (typeof error !== "undefined" && error !== null) {
      if (error.code === 400) {
        // captcha.current.reset();  
        executeRecaptcha();
      }
    }
  }, [error]);

  //////////////////////////////////////
  const storeOtpData = useSelector((state) => state.verifyOtp);
  const { otpData, loading: otpLoading, error: otpError } = storeOtpData;


  const storeOtpArnData = useSelector((state) => state.verifyOtpArn);
  const { otpArnData, load, err } = storeOtpArnData;
  ////////////////////////////////////////////////////////////////////////////

  //@---whenever listing data loaded set componet states

  useEffect(() => {
    console.log(otpData);

    if (typeof otpData !== "undefined" && otpData !== null) {
      if (otpData.otp_verified === 1) {

        let tempToken = JSON.parse(localStorage.getItem('tempToken'));
        let array = userData.data;
        array.id = tempToken;
        array.redirect_insuff = userData.redirect_insuff
        localStorage.setItem("userVerificationCandidate", JSON.stringify(array));
        if(userData?.redirect_insuff) {
          navigate("../candidate-form/insuff")
        }else{
          navigate("../dashboard");
        }
      }
    }
  }, [otpData,userData]);

  useEffect(() => {
    if (typeof otpArnData !== "undefined" && otpArnData !== null) {
      if (otpArnData?.status == "success") {
        localStorage.setItem("userVerification",JSON.stringify(otpArnData?.data));
        localStorage.setItem("userVerificationCandidate",JSON.stringify(otpArnData?.data));
        localStorage.setItem("tempToken",JSON.stringify(otpArnData?.token));
        // navigate('../ArnAuthorization');
        window.location.replace(base_url + '/ArnAuthorization');
      }
    }
  }, [otpArnData,storeOtpArnData]);

  const backHandler = (event) => {
    formData.email="";
    formData.password="";
    setLoginValidated(0);
    window.location.reload(true);
    otp1.current.value="";
    otp2.current.value="";
    otp3.current.value="";
    otp4.current.value="";
    otp5.current.value="";
    otp6.current.value="";
  };


  useEffect(() => {

    if(loginValidated === 1){

    const counter = timer > 0 && setInterval(() => setTimer(timer - 1), 1000);
    return () => clearInterval(counter);
    }
  }, [timer, loginValidated]);

  //console.log(timer);

  const resetTimer = function () {
    if (!timer) {
      setTimer(60);
    }
  };

  const resetOtpHandler = () => {
    let apiCompanyData;
    const runAPi = async () => {

      let userLocalData = JSON.parse(localStorage.getItem('tempToken')); 

      const requestData = {
        token: userLocalData,
      };
      const headers = {
        "Content-Type": "application/json",
        Username: "ibridge",
        Password: "ibridge@2020",
      };
      apiCompanyData = await axios.post(
        FOLDERPATH + "/GenericApi/resendOtp",
        requestData,
        {
          headers,
        }
      );
      // Reset the timer here
      resetTimer();

      setCount(count+1);
    };

    runAPi();
  };

  const resetOtpArnHandler2 = () => {
    let apiCompanyData;
    const runAPi = async () => {
      let tokenKey=localStorage.getItem("tokenKey");
      const requestData = {
        verifyToken: tokenKey,
      };
      const headers = {
        "Content-Type": "application/json",
        Username: "ibridge",
        Password: "ibridge@2020",
      };
      apiCompanyData = await axios.post(
        FOLDERPATH + "/CandidateApi/verifyArnLogin",
        requestData,
        {
          headers,
        }
      );

      const msg = "OTP sent successfully";

      toast.success(msg, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      // Reset the timer here
      resetTimer();

      setCount(count+1);
    };

    runAPi();
  };

  useEffect(()=>{
    const script = document.createElement('script')
    script.src="https://www.google.com/recaptcha/api.js?render=6LfXhNgmAAAAAC-C15y-2hx-w8oGHcVUuwMPv_Yf"
    script.addEventListener('load',executeRecaptcha)
    document.body.appendChild(script);
    try{
      let st = atob(tempStr);
      let arr = st.split('@@@');
      console.log(arr[1].length);
      if(arr.length == 2 && arr[1] && arr[1].length == 10){
        email.current.value = arr[0];
        password.current.value = arr[1];
      }
    }catch(error){
      console.log(error);
    }
 },[])

const executeRecaptcha = () => {
  window.grecaptcha.ready(()=>{
    window.grecaptcha.execute('6LfXhNgmAAAAAC-C15y-2hx-w8oGHcVUuwMPv_Yf').then((token)=>{
       setRecaptchaValue(token)
    setIsLoading(false)
  })
  })
}

const handleCheckboxChange = (event) => {
  setIsChecked(event.target.checked);
  if (event.target.checked) {
    // setError(""); // Clear error when checkbox is checked
    setFormError((prev) => ({
      ...prev,
      checkbox: ''
    }))
  }
};

  const exceptThisSymbols = ["e", "E", "+", "-", "."];
  return (
    <section className="login-page">
    {isLoading && <Loader />}
      <div className="container-fluid main-container">
        <div className="row main-row">
          {showOTP == false ? <> 
          <div className="col-sm-6 col-md-12 col-xl-6 left-sec h-100">
            <div className="p-4 h-100">
              <img src={Logo} alt="" className="desktop-logo" />

              <div className="d-flex align-items-center justify-content-center flex-column">
                <img
                  src={LoginImage}
                  alt=""
                  className="mt-3 mb-3 img-fluid login-image"
                />
                <div>
                  <h3 className="text-white fnt-smi-bld mb-4">AuthBridge</h3>
                  <p style={{ color: "#D0D5DD" }}>
                    With global capabilities, flagship identity management and
                    verification products, we have 1500+ happy customers across
                    25+ industries. We are driven by intelligent innovation and
                    a passion to build a secure world using technology.
                  </p>
                  <p style={{ color: "#D0D5DD" }}>
                    We are a trusted partner for all the stakeholders of the new
                    economy, we are market leaders and have helped shaped the
                    RegTech infrastructure in India.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div
            className={`col-sm-6 col-md-12 col-xl-6 right-sec align-items-center justify-content-center flex-column ${
              loginValidated === 0 ? "d-flex" : "d-none"
            }`}
          >
            <img src={LogoBlue} alt="" className="mobile-logo mb-4" />
            <form onSubmit={signinHandler} className="d-flex">
            <div className="m-4 form">
              <h4 className="fnt-bld text-center">Log in to continue</h4>
              <p
                className="fnt-sml-md text-center"
                style={{ color: "#667085" }}
              >
                Please enter your details.
              </p>

              <div className="">
                <div className="form-group">
                  <label htmlFor="" className="fnt-smi-bld">
                    Username
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter your username"
                    ref={email}
                  />
                  <p className="text-danger">{formError.email}</p>
                </div>
                <div className="form-group">
                  <label htmlFor="" className="fnt-smi-bld">
                    Password
                  </label>
                  <input
                    type="password"
                    className="form-control"
                    placeholder="Password"
                    ref={password}
                  />
                  <p className="text-danger">{formError.password}</p>
                  <div className="d-flex">
                  <input
                    type="checkbox"
                    id="termsCheckbox"
                    checked={isChecked}
                    onChange={handleCheckboxChange}
                    style={{
                      transform: "scale(1.5)",
                      marginRight: "10px",
                    }}
                  />
                  {/* <small className="text-danger ml-1">*</small> */}
                  <small className="ml-1" htmlFor="termsCheckbox">
                    I agree to processing of my personal information by AuthBridge in accordance with AuthBridge's 
                    <a href="https://ibridge.authbridge.com/home/privacy-policy/" target="_">
                      {" "}
                    Privacy Notice.
                    </a>
                    </small>
                  </div>
                  <p className="text-danger">{formError.checkbox}</p>
                </div>

                <div className="text-right">
                  <Link to="/forgot-password" className="text-primary fnt-sml-md fnt-sml">Resend Password</Link>
                </div>

                {/* <div className="re-captcha-box text-center d-flex justify-content-center mt-3">
                  <ReCAPTCHA
                    ref={captcha}
                    sitekey="6LffKE4UAAAAAD_CbxeHNWBGA45iUT_4ZUy0uIGs"
                      // onChange={() => {
                      //   captcha.current.reset(); // here
                      // }}
                  />
                </div> */}
                 <div
            className="g-recaptcha"
            data-sitekey="6LfXhNgmAAAAAC-C15y-2hx-w8oGHcVUuwMPv_Yf"
            data-size="invisible"
            ref={captcha}
            >

            </div>

                <button
                  className="w-100 btn btn-primary btn-block mt-3 btn-login"
                  // onClick={signinHandler}
                  type="submit"
                >
                  Sign in
                </button>
              </div>

              <div className="text-center fnt-sml mt-3">
                <span className="text-muted">Unable to sign in? </span>
                <a href="https://authbridge.com/contact-us" target="_blank" className="text-primary">
                  Contact Support
                </a>
              </div>
            </div>
            </form>
            <div class="copyright-login">
              <Footer/>
            </div>
          </div>


          <div
            className={`col-sm-6 col-md-12 col-xl-6 right-sec align-items-center justify-content-center flex-column-mbl ${
              loginValidated === 1 ? "d-flex" : "d-none"
            }`}
          >
            <div style={{width: '100%' , height: '100%', marginTop: 40}}>
            <div className="back-btn2 d-flex align-items-center"> 
            {
              /**
               * Just changed the className back-btn2 to avoid previous CSS
               */
            }
              <img src={BackArrowIcon} alt="" className="mr-2" />
              <span className="text-primary" onClick={backHandler}>
                Back to log in
              </span>
            </div>

            <form onSubmit={verifyOtpHandler} className="d-flex" style={{
              marginTop: 150, 
              position: 'relative',
              width: 'fit-content',
              marginLeft: 'auto',
              marginRight: 'auto',
              }}> 
            {
              /**
               * adding inline style for testing
               */
            }

            <div className="m-4 form">
              <h4 className="fnt-bld text-center">OTP Authentication</h4>
              <p
                className="fnt-sml-md text-center"
                style={{ color: "#667085" }}
              >
                Please enter one time password shared on your registered mobile
                no. {formatOtpMobileNumber(candidateNumber)}
              </p>

              <div className="">
                {/* <div className="form-group otp-inputs d-flex justify-content-center">
                  <input
                    type="number"
                    className="form-control fnt-bld"
                    maxLength="1"
                    ref={otp1}
                    name="otp1"
                    pattern="[0-9]*"
                    value={otpVal1}
                    onChange={handleOtpInputs}
                    onKeyDown={e => exceptThisSymbols.includes(e.key) && e.preventDefault()}
                    
                  />
                  <input
                    type="number"
                    className="form-control fnt-bld"
                    maxLength="1"
                    name="otp2"
                    ref={otp2}
                    pattern="[0-9]*"
                    value={otpVal2}
                    onChange={handleOtpInputs}
                    onKeyDown={e => exceptThisSymbols.includes(e.key) && e.preventDefault()}
                  />
                  <input
                    type="number"
                    className="form-control fnt-bld"
                    maxLength="1"
                    name="otp3"
                    ref={otp3}
                    pattern="[0-9]*"
                    value={otpVal3}
                    onChange={handleOtpInputs}
                     onKeyDown={e => exceptThisSymbols.includes(e.key) && e.preventDefault()}
                  />
                  <input
                    type="number"
                    className="form-control fnt-bld"
                    maxLength="1"
                    name="otp4"
                    ref={otp4}
                    pattern="[0-9]*"
                    value={otpVal4}
                    onChange={handleOtpInputs}
                    onKeyDown={e => exceptThisSymbols.includes(e.key) && e.preventDefault()}
                  />
                  <input
                    type="number"
                    className="form-control fnt-bld"
                    maxLength="1"
                    name="otp5"
                    ref={otp5}
                    pattern="[0-9]*"
                    value={otpVal5}
                    onChange={handleOtpInputs}
                    onKeyDown={e => exceptThisSymbols.includes(e.key) && e.preventDefault()}
                  />
                  <input
                    type="number"
                    className="form-control fnt-bld"
                    maxLength="1"
                    name="otp6"
                    ref={otp6}
                    pattern="[0-9]*"
                    value={otpVal6}
                    onChange={handleOtpInputs}
                    onKeyDown={e => exceptThisSymbols.includes(e.key) && e.preventDefault()}
                  />
                </div> */}
                <div className="form-group otp-inputs d-flex justify-content-center">
                  <OtpInput
                    value={OTPVal}
                    onChange={handleOTPChange}
                    numInputs={6}
                    isInputNum={true}
                    separator={<span>&nbsp;</span>}
                    inputStyle={{
                      height: "45px",
                      width: "30px",
                      border: "1px solid #84CAFF",
                      fontFamily: "Inter-Bold",
                      color: "blue",
                    }}
                  />
                </div>

                <button
                  className="btn btn-primary btn-block mt-3 btn-login"
                  // onClick={verifyOtpHandler}
                  type="submit"

                >
                  Verify OTP 
                </button>
              </div>

              <div className="text-center fnt-sml mt-3">
              { timer>0 ? ( 
                <span className="text-muted">
                  
                  Resend OTP in {timer} Seconds{" "}
                </span>):<>{ count==5 ? ( <span className="text-muted">
                  
                  No more attempts left{" "}
                  </span>):( 
                <span className="text-muted">
                  
                  Resend OTP in {timer} Seconds{" "}
                </span>)}</>}
                {timer === 0 && count<5 ? (
                  <Link
                    to="#"
                    className="text-primary"
                    onClick={resetOtpHandler}
                  >
                    Click to resend
                  </Link>
                ) : (
                  ""
                )}
              </div>
            </div>

            </form>
            </div>
            
            
            <div class="copyright-login">
              <Footer/>
            </div>
          </div>
          </>:''}
          <div
            className={`col-sm-6 col-md-12 col-xl-6 right-sec align-items-center justify-content-center flex-column-mbl ${
              showOTP==true ? "d-flex" : "d-none"
            }`}
          >
            <div style={{width: '100%' , height: '100%', marginTop: 40}}>
            <div className="back-btn2 d-flex align-items-center"> 
            {
              /**
               * Just changed the className back-btn2 to avoid previous CSS
               */
            }
              {/* <img src={BackArrowIcon} alt="" className="mr-2" /> */}
              <span className="text-primary" onClick={backHandler}>
                {/* Back to log in */}
              </span>
            </div>

            <form onSubmit={verifyOtpArnHandler} className="d-flex justify-content-center align-items-center h-100"
              // style={{
              //   marginTop: 150, 
              //   position: 'relative',
              //   width: 'fit-content',
              //   marginLeft: 'auto',
              //   marginRight: 'auto',
              // }}
            > 
            {
              /**
               * adding inline style for testing
               */
            }

            <div className="m-4 form mb-5">
              <div className="keyBlueIcon w-100 d-flex justify-content-center my-3">
                <img src={keyBlueIcon} alt="keyBlueIcon" />
              </div>
              <h4 className="fnt-bld text-center">OTP Authentication</h4>
              <p
                className="fnt-sml-md text-center"
                style={{ color: "#667085" }}
              >
                Please enter one time password shared on your registered mobile
                no. {candidateNumber}
              </p>

              <div className="">
                {/* <div className="form-group otp-inputs d-flex justify-content-center">
                  <input
                    type="number"
                    className="form-control fnt-bld"
                    maxLength="1"
                    ref={otp1}
                    name="otp1"
                    pattern="[0-9]*"
                    value={otpVal1}
                    onChange={handleOtpInputs}
                    onKeyDown={e => exceptThisSymbols.includes(e.key) && e.preventDefault()}
                    
                  />
                  <input
                    type="number"
                    className="form-control fnt-bld"
                    maxLength="1"
                    name="otp2"
                    ref={otp2}
                    pattern="[0-9]*"
                    value={otpVal2}
                    onChange={handleOtpInputs}
                    onKeyDown={e => exceptThisSymbols.includes(e.key) && e.preventDefault()}
                  />
                  <input
                    type="number"
                    className="form-control fnt-bld"
                    maxLength="1"
                    name="otp3"
                    ref={otp3}
                    pattern="[0-9]*"
                    value={otpVal3}
                    onChange={handleOtpInputs}
                     onKeyDown={e => exceptThisSymbols.includes(e.key) && e.preventDefault()}
                  />
                  <input
                    type="number"
                    className="form-control fnt-bld"
                    maxLength="1"
                    name="otp4"
                    ref={otp4}
                    pattern="[0-9]*"
                    value={otpVal4}
                    onChange={handleOtpInputs}
                    onKeyDown={e => exceptThisSymbols.includes(e.key) && e.preventDefault()}
                  />
                  <input
                    type="number"
                    className="form-control fnt-bld"
                    maxLength="1"
                    name="otp5"
                    ref={otp5}
                    pattern="[0-9]*"
                    value={otpVal5}
                    onChange={handleOtpInputs}
                    onKeyDown={e => exceptThisSymbols.includes(e.key) && e.preventDefault()}
                  />
                  <input
                    type="number"
                    className="form-control fnt-bld"
                    maxLength="1"
                    name="otp6"
                    ref={otp6}
                    pattern="[0-9]*"
                    value={otpVal6}
                    onChange={handleOtpInputs}
                    onKeyDown={e => exceptThisSymbols.includes(e.key) && e.preventDefault()}
                  />
                </div> */}
                <div className="form-group otp-inputs d-flex justify-content-center align-items-center flex-column w-100">
                  <OtpInput
                    value={OTPVal}
                    onChange={handleOTPChange}
                    numInputs={6}
                    isInputNum={true}
                    separator={<span>&nbsp;</span>}
                    inputStyle={{
                      height: "64px",
                      width: "64px",
                      borderRadius: "8px",
                      border: `${otpIncomplete == "wrong" ||otpIncomplete == "incomplete" ? "1px solid #D92D20" :"1px solid #84CAFF" }`,
                      fontFamily: "Inter-Bold",
                      fontSize: "48px",
                      fontWeight: 500,
                      lineHeight: "60px",
                      letterSpacing: "-0.02em",
                      textAlign: "center",
                      color: `${otpIncomplete == "wrong" ||otpIncomplete == "incomplete" ? "#D92D20" :"#1570EF" }`,
                    }}
                  />
                 {otpIncomplete == "wrong" ? <p style={{
                    fontFamily: "Inter, sans-serif",
                    width: "100%",
                    fontSize: "14px",
                    fontWeight: 400,
                    lineHeight: "20px",
                    letterSpacing: "0em",
                    textAlign: "left",
                    color: "#D92D20",
                 }}>Wrong OTP entered</p>: <p></p>}
                 {otpIncomplete == "incomplete" ? <p style={{
                    fontFamily: "Inter, sans-serif",
                    width: "100%",
                    fontSize: "14px",
                    fontWeight: 400,
                    lineHeight: "20px",
                    letterSpacing: "0em",
                    textAlign: "left",
                    color: "#D92D20",
                 }}>Please enter OTP</p>: <p></p>}

                </div>
                <div className="verifyButton w-100 d-flex justify-content-center">
                  <button
                    className="btn btn-primary btn-block w-75 btn-login"
                    // onClick={verifyOtpHandler}
                    type="submit"
                  >
                    Verify OTP 
                  </button>
                </div>
              </div>

              <div className="text-center fnt-sml mt-3">
              { timer>0 ? ( 
                <span className="text-muted">
                  
                  Resend OTP in {timer} Seconds{" "}
                </span>):<>{ count==5 ? ( <span className="text-muted">
                  
                  No more attempts left{" "}
                  </span>):( 
                <span className="text-muted">
                  
                  Resend OTP in {timer} Seconds{" "}
                </span>)}</>}
                {timer === 0 && count<5 ? (
                  <Link
                    to="#"
                    className="text-primary"
                    onClick={resetOtpArnHandler2}
                  >
                    Click to resend
                  </Link>
                ) : (
                  ""
                )}
              </div>
            </div>

            </form>
            </div>
            
            
            <div class="copyright-login">
              <Footer/>
            </div>
          </div>

          { showOTP == true ? <div className="col-sm-6 col-md-12 col-xl-6 left-sec otp-right-sec h-100 p-0" style={{
            backgroundImage: "url('../img/login.jpg')",
            backgroundSize: "100%",
          }}>
              <div className="h-100">
                {/* <img src={Logo1} alt="" className="desktop-logo" style={{maxHeight: '100%',maxWidth: '100%'}}/> */}
                <div className="bl_logo">
                  <img src={LogoBlue} alt="" className="desktop-logo" />
                </div>
                <div className="d-flex align-items-center justify-content-center flex-column">
                  <div className="slide_bar">
                    <div class="inner">
                      <div
                        id="carouselExampleControls"
                        className="carousel slide"
                        data-ride="carousel"
                      >
                        <div className="carousel-inner login-screen">
                          <div className="carousel-item active">
                            <h1 className="m-0">
                              “AuthBridge is an important partner of PropTiger
                              because they are owning the most important process
                              of onboarding which is screening of employee”.
                            </h1>
                            <div className="card_detail mt-2">
                              <span>
                                <h3 className="m-0">Vikas W</h3>
                              </span>
                              <span className="card_i">
                                <span className="icon fas fa-star"></span>
                                <span className="icon fas fa-star"></span>
                                <span className="icon fas fa-star"></span>
                                <span className="icon fas fa-star"></span>
                                <span className="icon fas fa-star"></span>
                              </span>
                            </div>
                            <div
                              className="crd fnt-smi-bld fnt-18 mt-2"
                              style={{ color: "#FFFFFF" }}
                            >
                              {" "}
                              Chief Financial officer<br></br>
                              <div style={{ fontWeight: "300" }}>Proptiger</div>
                            </div>
                          </div>

                          <div className="carousel-item">
                            <h1>
                              “AuthBridge is an important partner of PropTiger
                              because they are owning the most important process
                              of onboarding which is screening of employee”.
                            </h1>
                            <div className="card_detail mt-2">
                              <span>
                                <h3 className="m-0">Vikas T</h3>
                              </span>
                              <span className="card_i">
                                <span className="icon fas fa-star"></span>
                                <span className="icon fas fa-star"></span>
                                <span className="icon fas fa-star"></span>
                                <span className="icon fas fa-star"></span>
                                <span className="icon fas fa-star"></span>
                              </span>
                            </div>

                            <div
                              className="crd fnt-smi-bld"
                              style={{ color: "#FFFFFF" }}
                            >
                              {" "}
                              Chief Finacial officer<br></br>
                              <div style={{ fontWeight: "300" }}>Proptiger</div>
                            </div>
                          </div>
                          {/* <div className="carousel-item"></div> */}
                        </div>
                        <div class="next-prev-btn">
                          <button
                            className="carousel-control-prev"
                            type="button"
                            data-target="#carouselExampleControls"
                            data-slide="prev"
                          >
                            <span className="slider-back-btn">
                              <FeatherIcon icon="arrow-left" />
                            </span>
                            <span className="sr-only">Previous</span>
                          </button>
                          <button
                            className="carousel-control-next"
                            type="button"
                            data-target="#carouselExampleControls"
                            data-slide="next"
                          >
                            <span className="slider-back-btn">
                              <FeatherIcon icon="arrow-right" />
                            </span>
                            <span className="sr-only">Next</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div> : <></> }

        </div>
      </div>
    </section>
  );
};
export default Login;